import { featureHasUsages, getFeatureLimitsData } from 'src/data/featureLimits';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerCanCreateFeatureItem = (featureLimit) => {
  const currentCustomer = useCurrentCustomer();
  const featureLimitsData = getFeatureLimitsData(currentCustomer, featureLimit);

  return featureHasUsages(featureLimitsData);
};
